import React from "react";
import ReactDOM  from "react-dom/client";
import axios from "axios";


import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./accet/App.css";


const root = ReactDOM.createRoot(document.getElementById('root'));

const {REACT_APP_PASS,REACT_APP_USER,REACT_APP_API_URL, REACT_APP_PORT, REACT_APP_API} = process.env;

//console.log(process.env);
//console.log(REACT_APP_BASE_URL);

const axiosConfig = {
    headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        "Access-Control-Allow-Origin": "*",
    }
  };

const param = {
                        
    user: REACT_APP_USER,
    pass: REACT_APP_PASS,
    
}
//:${REACT_APP_PORT}
 
axios.post(`${REACT_APP_API_URL}:${REACT_APP_PORT}/${REACT_APP_API}/log920in`,param,  axiosConfig)
                    .then((res)=>{
                        
  
                        
                        
                        console.log(res);
                    // alert(res.status);
                                            

                        if (res.status===200)
                        {
                            console.log(res.data.token);
                            
                            root.render(<App token={res.data.token} URL={REACT_APP_API_URL} PORT={REACT_APP_PORT} />);                            

                            // onSubmitProps.resetForm(initialValues); 
                        }   

                        //setformValues(initialValues);
                        
                    })
                    .catch((err) => {
                        console.log(err.message);
                });


